module.exports = __webpack_public_path__ + "static/media/Legend-Key-BTSC.3918c136.jpg";